import * as httpx from "httpx"
import * as events from "./events"
import { CancellablePromise } from "real-cancellable-promise"
import {
	VideoSearchRequest,
	VideoSearchResponse,
	VideoPatchRequest,
	VideoPatchResponse,
} from "brandguard/brandguard.video_pb"
import * as uploads from "./uploads"

export function search(
	bid: string,
	req: VideoSearchRequest,
	...options: httpx.option[]
): CancellablePromise<VideoSearchResponse> {
	return httpx.get<VideoSearchResponse>(`${httpx.urlstorage.host()}/bg/video/${bid}`, req, ...options).then((resp) => ({
		...resp,
		items: (resp.items || []).map((item) => ({ media: item.media, event: events.zero(item.event) })),
		next: uploads.searches.zero(resp.next),
	}))
}

export function publish(
	id: string,
	bid: string,
	req: VideoPatchRequest,
	...options: httpx.option[]
): Promise<VideoPatchResponse> {
	return httpx
		.post<VideoPatchResponse>(`${httpx.urlstorage.host()}/bg/video/${bid}/${id}/reviewed`, req, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}
